function validateNumeric (val) {
  try {
    var key = arguments[arguments.length - 1]
    var minKey = [key, 'numeric', 'min'].join('.')
    var maxKey = [key, 'numeric', 'max'].join('.')
    var valueKey = [key, 'numeric', 'value'].join('.')
    var args = {}

    // parse numeric condition arguments
    for (var i = 1; i < arguments.length - 1; i++) {
      var parsed = arguments[i].split(':')
      if (parsed.length !== 2) { continue }
      if (isNaN(parsed[1])) { continue }
      args[parsed[0]] = parseInt(parsed[1])
    }

    if (isNaN(val)) {
      this.$validation[valueKey] = true
      if ('min' in args) {
        this.$validation[minKey] = false
      }
      if ('max' in args) {
        this.$validation[maxKey] = false
      }
    } else {
      this.$validation[valueKey] = false

      var value = parseInt(val)

      // validate min
      if ('min' in args) {
        this.$validation[minKey] = (value < args['min'])
      }

      // validate max
      if ('max' in args) {
        this.$validation[maxKey] = (value > args['max'])
      }
    }
  } catch (e) {
    console.error('numeric filter error:', e)
  }

  return val
}


module.exports = function(Vue) {
  Vue.filter('numeric', validateNumeric);
}


// WEBPACK FOOTER //
// ./lib/vue-filters/index.js